import { twJoin } from "tailwind-merge"
import { cn } from "../lib/utils"

function ListTextPreview({ data, editable, theme, heading }) {
  let textColor = "text-brand"
  if (theme == "encouragement") {
    textColor = "text-encouragement"
  }
  if (theme == "commitments") {
    textColor = "text-commitments"
  }

  return (
    <>
      {heading && <div className={cn("mb-2 text-2xl font-bold", textColor)}>{heading}</div>}
      <ul>
        {data.map((item, index) => {
          return (
            <li key={index} className="mb-2 flex gap-2 border-b border-neutral-200 pb-2">
              <span className={textColor}>{index + 1}) </span>
              <span className={twJoin("mt-0.5 text-sm", editable ? "text-black" : "text-black")}>
                {item.user_name} - {item.value}
              </span>
            </li>
          )
        })}
      </ul>
    </>
  )
}

export default ListTextPreview
